import { render, staticRenderFns } from "./CommunitySocial.vue?vue&type=template&id=681b91d4&scoped=true&"
import script from "./CommunitySocial.vue?vue&type=script&lang=js&"
export * from "./CommunitySocial.vue?vue&type=script&lang=js&"
import style0 from "./CommunitySocial.vue?vue&type=style&index=0&id=681b91d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b91d4",
  null
  
)

export default component.exports